module.exports = __webpack_public_path__ + "static/media/71.b8c273fb.jpg";